(function () {
  function getActiveIndex(claims, stickyEl) {
    if (!claims.length) return -1;

    var stickyRect = stickyEl.getBoundingClientRect();
    var useStickyAnchor = window.matchMedia('(min-width: 992px)').matches;
    var referenceY = useStickyAnchor
      ? stickyRect.top + stickyRect.height * 0.35
      : window.innerHeight * 0.4;
    var activeIndex = 0;

    for (var i = 0; i < claims.length; i++) {
      var claimRect = claims[i].getBoundingClientRect();
      if (claimRect.top <= referenceY) {
        activeIndex = i;
      }
    }

    return activeIndex;
  }

  function updateActiveClaim(section) {
    var stickyEl = section.querySelector('[data-sell-truth-sticky]');
    var claims = section.querySelectorAll('[data-sell-truth-claim]');
    if (!stickyEl || !claims.length) return;

    var activeIndex = getActiveIndex(claims, stickyEl);

    claims.forEach(function (claim, index) {
      claim.classList.toggle('is-active', index === activeIndex);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.sellTruthInit === 'true') return;
    section.dataset.sellTruthInit = 'true';

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateActiveClaim(section);
        ticking = false;
      });
    }

    updateActiveClaim(section);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    section._sellTruthCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-about-sell-truth]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-about-sell-truth]');
    if (section) {
      section.dataset.sellTruthInit = '';
      initSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-about-sell-truth]');
    if (section && typeof section._sellTruthCleanup === 'function') {
      section._sellTruthCleanup();
    }
  });
})();
